/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import { connect } from 'react-redux'
import { Form, Modal, Divider, Checkbox, Grid, Button } from 'semantic-ui-react'
import _ from 'lodash'

import firebase from '../../../config/firebase'

class CloneItemOptionForm extends React.PureComponent {
  state = {
    search: '',
    loading: false,
    searching: false,
    data: null,
    selectedOptionIds: [],
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  onSearchChange = e => {
    const { data } = this.state
    const search = e.target.value

    this.setState({ search, data: _.size(data) > 0 ? data : null })
  }

  onSearch = async () => {
    const { search } = this.state
    const ref = firebase
                  .firestore()
                  .collection('item_options')
                  .where('keywords', 'array-contains', search.toLowerCase())

    await this.setStateAsync({ searching: true })

    const snapshot = await ref.get()
    const itemOptions = []

    snapshot.forEach(itemOption => {
      itemOptions.push({ ...itemOption.data(), id: itemOption.id })
    })

    this.setState({ selectedOptionIds: [], data: _.groupBy(itemOptions, 'store_id'), searching: false })
  }

  onCopyClick = async () => {
    const { storeId, onClose } = this.props
    const { selectedOptionIds, data } = this.state

    const itemOptions = _.chain(data).values().flatten().value().reduce(
      (result, { id, ...itemOption }) => {
        result[id] = { ...itemOption, store_id: storeId}
        return result
      }, {})

    await this.setStateAsync({ loading: true })

    selectedOptionIds.forEach(async ioId => {
      const ref = firebase.firestore().collection('item_options').doc()
      await ref.set(itemOptions[ioId])
    })

    await this.setStateAsync({ loading: false })
    onClose()
  }

  onItemOptionChange = itemOptionId => {
    const { selectedOptionIds } = this.state

    const newSelectedOptionIds = selectedOptionIds.includes(itemOptionId)
                                  ? selectedOptionIds.filter(optionId => optionId !== itemOptionId)
                                  : selectedOptionIds.concat(itemOptionId)

    this.setState({ selectedOptionIds: newSelectedOptionIds })
  }

  renderNoResult = () => {
    const { search } = this.state

    return (
      <p style={{ marginTop: 100, textAlign: 'center' }}>
        No Result Found for &quot;{search}&quot;
      </p>
    )
  }

  renderResult = () => {
    const { data, selectedOptionIds } = this.state
    const { stores } = this.props

    const keys = _.keys(data)

    const halfLength = Math.ceil(keys.length / 2)
    const chunkedStoreIds = _.chunk(keys, halfLength)

    return (
      <Grid columns={2} style={{ marginTop: 10 }}>
        <Grid.Row>
          {
            chunkedStoreIds.map((storeIds, index) => (
              <Grid.Column key={index}>
                {
                  storeIds.map(storeId => (
                    <div key={storeId} style={{ marginBottom: 40 }}>
                      <h4>
                        { stores[storeId] ? stores[storeId].name : 'No Name' }
                      </h4>
                      <Divider />
                      {
                        data[storeId].map(itemOption => (
                          <Checkbox
                            style={{ marginBottom: 10 }}
                            label={`${itemOption.name} - (${_.map(itemOption.choices, 'name').join(', ')})`}
                            checked={selectedOptionIds.includes(itemOption.id)}
                            onChange={() => this.onItemOptionChange(itemOption.id)}
                          />
                        ))
                      }
                    </div>
                  ))
                }
              </Grid.Column>
            ))
          }
        </Grid.Row>
      </Grid>
    )
  }

  render() {
    const {  loading, search, data, selectedOptionIds, searching } = this.state
    const { visible, onClose } = this.props

    return (
      <Modal
        onClose={onClose}
        open={visible}
        size="small"
        style={{ marginTop: 0 }}
      >
        <Modal.Content
          className="branch-form"
          style={{ height: 500, overflow: 'auto' }}
        >
          <Form disabled={loading} onSubmit={this.onSearch}>
            <Form.Input
              fluid
              iconPosition='left'
              icon='search'
              placeholder='Item Option Search'
              required
              onChange={this.onSearchChange}
              value={search}
              loading={searching}
            />
          </Form>
          { data && _.size(data) === 0 && this.renderNoResult() }
          { data && _.size(data) > 0 && this.renderResult() }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            onClick={this.onCopyClick}
            color="black"
            loading={loading}
            disabled={loading || selectedOptionIds.length === 0}
          >
            Copy
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ restaurants }) => ({
  stores: restaurants.data
})

export default connect(mapState)(CloneItemOptionForm)



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/cloneItemOptionForm.js